module.exports = __webpack_public_path__ + "static/product-commerce2x-shopping-6bd8b24998458f16b1f55d1f2d9b295f.png";